import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';

const SaveConfirmationModal = ({ isOpen, onClose, onConfirm, message, title = "Confirm Save" }) => {
  const saveIcon = (
    <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
      <svg className="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
  );

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message || "Are you sure you want to save these changes?"}
      confirmButtonText="Save"
      confirmButtonClass="bg-green-600 hover:bg-green-700 focus:ring-green-500"
      iconComponent={saveIcon}
    />
  );
};

SaveConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string
};

export default SaveConfirmationModal;